/**
 * @file theme-reset.ts
 * @description «Начать с вида по умолчанию» (phase19.16 Р1; SB120 этап 4 —
 * решение ревью 2026-10-19): цвета, шрифты, формы, фон и рамка — умолчание
 * платформы; шапка, подвал и вид корзины остаются, как были (их раскладка —
 * свои панели). Один источник для «⋯» конструктора (`BuilderTopBar`) и
 * панели «Оформление» (`AppearancePanel`).
 *
 * Партия «Юридические документы» (SB142, проект данных §6.1): свои строки
 * «Ссылок» подвала (`footerDocs`) — содержание сайта, а не вид; сброс их
 * сохраняет, как шапку, подвал и корзину.
 */

import { DEFAULT_SITE_THEME, type SiteTheme } from "@chaiberi/shared";

import { cartOf } from "./cart-look";

/** Текст окна подтверждения. */
export const THEME_RESET_TITLE = "Начать с вида по умолчанию?";
export const THEME_RESET_DESCRIPTION =
  "Заменить в черновике все цвета, шрифты и формы на вид по умолчанию платформы? Шапка, подвал и вид корзины останутся. Сайт не изменится до публикации.";

/** Тема по умолчанию с прежними шапкой, подвалом, своими ссылками подвала и видом корзины. */
export function themeResetKeepingShell(theme: SiteTheme): SiteTheme {
  // Раздел `footerDocs` всегда есть: тема без него читается умолчанием (`readSiteTheme`).
  return { ...(structuredClone(DEFAULT_SITE_THEME) as SiteTheme), header: theme.header, footer: theme.footer, cart: cartOf(theme), footerDocs: theme.footerDocs };
}
